export default {
  title: "FAQ",
  subtitle: "Manage frequently asked questions",

  addNew: "Add New FAQ",
  createFaq: "Create FAQ",
  editFaq: "Edit FAQ",
  deleteFaq: "Delete FAQ",

  actions: {
    back: "Back",
    update: "Update",
    updating: "Updating..."
  },

  fields: {
    category: "Category",
    question: "Question",
    answer: "Answer",
    displayOrder: "Display Order",
    isActive: "Active"
  },

  placeholders: {
    category: "Select category",
    question: "Enter question in Arabic and English",
    answer: "Enter answer in Arabic and English"
  },

  messages: {
    createSuccess: "FAQ created successfully",
    createError: "Failed to create FAQ",
    updateSuccess: "FAQ updated successfully",
    updateError: "Failed to update FAQ",
    deleteSuccess: "FAQ deleted successfully",
    deleteError: "Failed to delete FAQ",
    deleteConfirm: "Are you sure you want to delete this FAQ?",
    noFaq: "No FAQ items found",
    fetchError: "Failed to fetch FAQ"
  },

  validation: {
    categoryRequired: "Category is required",
    questionRequired: "Question is required",
    answerRequired: "Answer is required",
    fillAllFields: "Please fill all required fields"
  },

  table: {
    displayOrder: "Order",
    category: "Category",
    question: "Question",
    answer: "Answer",
    status: "Status",
    actions: "Actions"
  },

  status: {
    active: "Active",
    inactive: "Inactive"
  },

  breadcrumbs: {
    faq: "FAQ",
    create: "Create FAQ",
    edit: "Edit FAQ"
  }
};
